export default "__VITE_ASSET__DX8yPL1V__"